export const MISSING_CRUISE = "missingCruise" as const
export const FATAL = "fatal" as const
export const TRANSIENT = "transient" as const
export const NO_AVAILABILITY_FOR_OCCUPANCY = "noAvailabilityForOccupancy" as const
